import crudHandlers from "./_crud";

const initialState = {
    entities: []
};

export default (state = initialState, action) => {  // Definir el valor predeterminado de `state`
    const { type } = action;

    switch (type) {
        // Puedes agregar más casos para manejar diferentes acciones aquí

        default:
            // No debes mutar directamente el estado, usa el operador de propagación para asegurar inmutabilidad
            return crudHandlers(state, action, 'notification_configuration');
    }
};
